export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-36 px-6 md:px-10 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20photography%20of%20diverse%20fashion%20items%20including%20folded%20terracotta%20sweater%20white%20sneakers%20leather%20bag%20and%20accessories%20arranged%20in%20circular%20composition%20on%20light%20oak%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20fashion%20photography%2C%20elegant%20balanced%20composition%2C%20warm%20earthy%20tones%2C%20European%20contemporary%20aesthetic&width=1920&height=800&seq=hoobuy-cta-v2-2026-x7p1&orientation=landscape"
          alt="Comece agora com Hoobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/30 to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl">
        <h2 className="font-heading text-4xl md:text-5xl text-white font-semibold mb-6 leading-tight">
          Buy It Now
        </h2>
        <p className="text-white/80 text-sm md:text-base max-w-md mb-8 leading-relaxed">
          Explore a melhor spreadsheet Hoobuy agora mesmo. Encontre produtos verificados e comece a comprar com segurança.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-900 text-sm md:text-base font-semibold rounded-full hover:bg-white/95 transition-all whitespace-nowrap cursor-pointer group"
        >
          buy it now
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white group-hover:bg-primary-600 transition-colors">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </a>
      </div>
    </section>
  );
}